// extracted by mini-css-extract-plugin
export default {"botao-email":"BotaoEmail_botao-email__6Wzms","menu":"BotaoEmail_menu__dkciP","menu-responsive":"BotaoEmail_menu-responsive__NX9Lq","actions":"BotaoEmail_actions__8vfma"};